/**
 * Course Repository Interface
 * Defines contract for course data access
 */

export class ICourseRepository {
  /**
   * Get course by ID
   * @param {string} courseId
   * @returns {Promise<Course|null>}
   */
  async getCourseById(courseId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get all courses
   * @returns {Promise<Course[]>}
   */
  async getAllCourses() {
    throw new Error('Method not implemented');
  }

  /**
   * Get section by ID
   * @param {string} courseId
   * @param {string} sectionId
   * @returns {Promise<Section|null>}
   */
  async getSectionById(courseId, sectionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get all sections for a course
   * @param {string} courseId
   * @returns {Promise<Section[]>}
   */
  async getSectionsForCourse(courseId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get question by ID
   * @param {string} courseId
   * @param {string} questionId
   * @returns {Promise<Question|null>}
   */
  async getQuestionById(courseId, questionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get all questions for a section
   * @param {string} courseId
   * @param {string} sectionId
   * @returns {Promise<Question[]>}
   */
  async getQuestionsForSection(courseId, sectionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Get all questions grouped by section for a course
   * @param {string} courseId
   * @returns {Promise<Record<string, Question[]>>}
   */
  async getQuestionsForCourse(courseId) {
    throw new Error('Method not implemented');
  }

  /**
   * Create a new course
   * @param {Object} courseData
   * @returns {Promise<Course>}
   */
  async createCourse(courseData) {
    throw new Error('Method not implemented');
  }

  /**
   * Update an existing course
   * @param {string} courseId
   * @param {Object} courseData
   * @returns {Promise<Course>}
   */
  async updateCourse(courseId, courseData) {
    throw new Error('Method not implemented');
  }

  /**
   * Delete a course
   * @param {string} courseId
   * @returns {Promise<boolean>}
   */
  async deleteCourse(courseId) {
    throw new Error('Method not implemented');
  }
}
